import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, registerables, TimeScale } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import "chartjs-adapter-date-fns";
import { Card } from "./";

ChartJS.register(...registerables, TimeScale, zoomPlugin);

const BandedChart = ({ chartData }) => {
  const uclData = chartData?.break_data?.map((item) => Number(item.ucl));
  const maData = chartData?.break_data?.map((item) => Number(item.ma));
  const lclData = chartData?.break_data?.map((item) => Number(item.lcl));
  const ratioData = chartData?.break_data?.map((item) => {
    return {
      ratio: Number(item.ratio),
      broken: item.broken,
    };
  });
  const data = {
    labels: chartData?.break_data?.map((item) => new Date(item.timestamp)),
    datasets: [
      {
        label: "Ratio",
        data: ratioData?.map((item) => item.ratio),
        borderColor: "rgba(194, 207, 214, 1)",
        backgroundColor: "rgba(84, 112, 125, 1)",
        borderWidth: 1,
        pointRadius: ratioData?.map((item) => (item.broken ? 1 : 0)),
        pointStyle: "circle",
      },
      {
        label: "Upper Limit",
        data: uclData,
        borderColor: "rgba(87, 168, 255, 1)",
        backgroundColor: "rgba(204, 228, 255, 1)",
        borderWidth: 1,
        pointRadius: 0,
        pointStyle: "circle",
      },
      {
        label: "MA",
        data: maData,
        borderColor: "#7F0DF1",
        backgroundColor: "#7F0DF1",
        borderWidth: 1,
        fill: false,
        pointRadius: 0,
        pointStyle: "circle",
      },
      {
        label: "Lower Limit",
        data: lclData,
        borderColor: "rgba(87, 168, 255, 1)",
        backgroundColor: "rgba(204, 228, 255, 1)",
        borderWidth: 1,
        fill: "-2",
        pointRadius: 0,
        pointStyle: "circle",
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "hour",
          displayFormats: {
            hour: "yyyy-MM-dd HH:mm",
          },
        },
        adapters: {
          date: {
            zone: "utc",
          },
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 20,
        },
      },
      y: {
        min: 0,
        max: 0.001,
        grid: {
          drawBorder: true,
        },
        ticks: {
          callback: function (value) {
            return value.toFixed(5);
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          boxWidth: 20,
          boxHeight: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toFixed(5);
            }
            return label;
          },
        },
      },
      zoom: {
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
        },
        pan: {
          enabled: true,
        },
      },
    },
  };

  return (
    <div className="relative w-full h-full">
      <Line className="!w-full !h-full" data={data} options={options} />
    </div>
  );
};

export const Charts = ({ charts, carts }) => {
  return (
    <div
      className={`${
        charts?.length > 2 ? "grid grid-cols-2 gap-4" : "flex flex-col gap-4"
      } w-full py-8 px-4 max-h-[88vh] overflow-y-auto scrollbar-style-thumb scrollbar-style `}
    >
      {charts?.map((item, index) => {
        const cart = carts?.find(
          (cartItem) =>
            cartItem.pair.key === item.pair.key && cartItem.timeframe === item.timeframe
        );

        return (
          <div
            className={` flex flex-col gap-5 bg-storm-light rounded-2xl p-5`}
            key={index}
          >
            <Card
              pair={cart?.pair}
              timeFrame={cart?.timeframe}
              breakCount={cart?.breakCount}
            />

            <BandedChart chartData={item} />
          </div>
        );
      })}
    </div>
  );
};

export default Charts;
